import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { PopChannelsComponent } from 'src/app/components/pop-channels/pop-channels.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Service } from '../../../services';
import { PopUpTermsOffersComponent } from './components/pop-up-terms-offers/pop-up-terms-offers.component';
import { Observable } from 'rxjs';

interface channelList {
  idPlan: number,
  channels: []
}
@Component({
  selector: 'app-plan-selection-iptv',
  templateUrl: './plan-selection-iptv.component.html',
  styleUrls: ['./plan-selection-iptv.component.sass']
})
export class PlanSelectionIptvComponent implements OnInit {
  public ssoAccessToken:string='';
  public myPlans: any = [];
  public myPlansData = [];
  public channelGuideList = [];
  public channelGuideListData = [];
  public channelList: any = [];
  public screen: number = Number(sessionStorage.getItem("PlanSelectionScreen"));
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public session: number;
  public content: object;
  public token: string = sessionStorage.getItem("token");
  public idPlan: string;
  public carouselMode: number;
  public makeChange: any;
  public hasChange: boolean = false;
  public hasLogin:boolean=false;
  public idPlanAux: string = "0";
  @Input() checkIptv;
  constructor(private route: ActivatedRoute,private services: Service, public dialog: MatDialog, private active: ActivatedRoute, public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router, private loadingScreenService: LoadingScreenService) {
    this.ssoAccessToken=sessionStorage.getItem("SSOAccessToken");
    this.AngularFireAnalytics.setCurrentScreen("Netflix");
    this.AngularFireAnalytics.logEvent("Netflix-Screenview");
    let w: number;
    this.global.resizeObservable.subscribe((e: any) => {
      if (e.target.innerWidth !== w) {
        this.carouselSetup();
      }
      w = e.target.innerWidth;
    });
  }
  ngOnInit() {
    this.global.tokenShop = sessionStorage.getItem("tokenShop");
    if (sessionStorage.getItem('makeChange') != null) {
      this.makeChange = JSON.parse(sessionStorage.getItem('makeChange') || '{}');
      this.idPlan = this.makeChange.productId;
      this.idPlanAux = this.idPlan;
      this.hasChange = true;
    }
    else {
      this.idPlan = String(sessionStorage.getItem("idPlan"));
    }
    if (this.screen == 0) {
      this.screen = 1;
    }
    this.dataLoading();
  }
  dataLoading() {
    this.loadingScreenService.startLoading();
    this.services.listCatalogue(this.token, 11, 1, 100, "", "", "", 0, "", "").subscribe((data: any) => {
      this.loadingScreenService.stopLoading();
      this.myPlansData = data.catalogs[2].catalog[0].products;
      this.services.channelsFull(this.token).subscribe((list: any) => {
        this.channelGuideListData = list;
        this.carouselSetup();
        this.loadChannelsList();
      });
    });
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  changeTab(idSession) {
    this.global.validateSession();
    this.session = idSession;
  }
  selectPlan(id: string) {
    this.idPlan = id;
  }
  openPupUp() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { channels: this.channelGuideListData };
    const dialogRef = this.dialog.open(PopChannelsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
    });
  }
  goToChannelList(id: number = 0, name: string = '') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { planId: id, planName: name };
    const dialogRef = this.dialog.open(PopChannelsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
    });
  }
  goToBuy(planId: string, check: boolean, price: number) {
    if(this.hasLogin==true){
      check = true;
      if (sessionStorage.getItem("buyBlock") == 'true') {
        this.global.balancePendient('home');
      }
      else {
        if (check == true) {
          if (this.checkIptv == true) {
            let items: any;
            this.verificationOfChanges().subscribe((data: any) => {
              items = this.global.addToCart(0, 0, planId, this.global.creditClass, price, 0, price, 1, 0);
              this.global.sendCart(items, parseInt(planId)).subscribe((hasError) => {
                this.loadingScreenService.stopLoading();
                if (hasError == false) {
                  sessionStorage.setItem('email', null);
                  sessionStorage.removeItem('makeChange');
                  this.global.cartItems = [];
                  this.router.navigate(['buy_process']);
                }
              });
            });
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif("Estimado cliente, su tipo de cuenta o plan actual no es elegible para adquirir este servicio. Para mayor información consulte la sección de Términos y Condiciones o Soporte Técnico.");
          }
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif("Por favor acepte los términos y condiciones.");
        }
      }
    }
    else{
      this.loadingScreenService.startLoading();
      setTimeout(() => {
        this.goToBuy(planId, check, price);
      }, 30000);
    }

  }
  dataPlanSelect(idPlan: string) {
    for (let i = 0; i < this.myPlansData.length; i++) {
      for (let j = 0; j < this.myPlansData[i].length; j++) {
        if (this.myPlansData[i][j].productId == idPlan) {
          return JSON.stringify(this.myPlansData[i][j]);
        }
      }
    }
    return null;
  }
  carouselSetup() {
    if (window.innerWidth > 968) {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 3);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 10);
    }
    else if (window.innerWidth > 680 && window.innerWidth <= 968) {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 2);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 6);
    }
    else {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 1);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 2);
    }
  }
  jsonChannels(idPlan: number) {
    for (let i = 0; i < this.channelList.length; i++) {
      if (this.channelList[i].idPlan == idPlan) {
        return this.channelList[i].channels;
      }
    }
  }
  loadChannelsList() {
    for (let i = 0; i < this.myPlans.length; i++) {
      for (let j = 0; j < this.myPlans[i].length; j++) {
        this.loadingScreenService.startLoading();
        this.services.channelsList(this.token, this.myPlans[i][j].productId, 0, 8).subscribe((data: any) => {
          this.loadingScreenService.stopLoading();
          let json: channelList = {
            idPlan: this.myPlans[i][j].productId,
            channels: data
          }
          this.channelList.push(json);
        });
      }
    }
    this.getToken();
  }
  getId() {
    if (this.route.firstChild) {
      var id = String(this.route.firstChild.snapshot.params.id);
      if (id == "1") {
        this.scrollToAnchor(id);
      }
    }
    else {
      window.scroll(0, 0);
    }
  }
  scrollToAnchor(anchor: string) {
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/iptv'], { fragment: anchor }).finally(() => {
      this.router.onSameUrlNavigation = 'ignore';
    });
  }
  showterms(offer: any) {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { offer };
    this.dialog.open(PopUpTermsOffersComponent, dialogConfig);
  }
  verificationOfChanges() {
    const changeObservable = new Observable(observer => {
      if (this.hasChange == true) {
        this.loadingScreenService.startLoading();
        this.services.deleteItem(0, 0, this.global.tokenShop).subscribe((data: any) => {
          if (data.hasError == false) {
            observer.next();
          }
          else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDesc);
          }
        });
      }
      else {
        observer.next();
      }
    });
    return changeObservable;
  }
  goToTerms() {
    let templatePath = 'assets/template/terms-ClaroTv.html';
    let title = 'Términos y Condiciones';
    this.global.showTerms('template', title, templatePath, false).subscribe(data => {
    });
  }
  getToken() {
    this.services.getToken().subscribe((data: any) => {
      let sw=false;
      this.services.loginTokenSSO(this.ssoAccessToken,data.token).subscribe(data1 => {
        if(data1.hasError==false){
          this.hasLogin=true;
          for (let i = 0; i < data1.response.customerInfo.accountList.length; i++) {
            if (data1.response.customerInfo.accountList[i].accountQualifications.iptvCapable.iptvCapable == true) {
              sessionStorage.setItem("banExisting", data1.response.customerInfo.accountList[i].ban);
              sessionStorage.setItem("subscriberExisting",data1.response.customerInfo.accountList[i].accountQualifications.iptvCapable.subscriberCapable);
              sw=true;
              break;
            }
          }
          for (let i = 0; i < data1.response.customerInfo.accountList.length; i++) {
            if(data1.response.customerInfo.accountList[i].delinquencyStatus==true && data1.response.customerInfo.accountList[i].totalBalance > 0 && data1.response.customerInfo.accountList[i].accountSubType=='W' && data1.response.customerInfo.accountList[i].accountType=='I'){
              sessionStorage.setItem("buyBlock", 'true');
              this.global.buyBlock = true;
              this.global.totalBalance=data1.response.customerInfo.accountList[i].totalBalance;
              sessionStorage.setItem("totalBalance", this.global.totalBalance.toString());
            }
          }
          if(sw==false){
            this.checkIptv=false;
          }
          sessionStorage.setItem("tokenShop", data.token);
          this.global.tokenShop=sessionStorage.getItem("tokenShop");
          //this.getId();
        }
        else{
          this.loadingScreenService.stopLoading();
          this.global.notif(data1.errorDesc);
        }
      });
    });
  }
}
